const header = document.querySelector('[data-header]');
const hamburger = document.querySelector('[data-header-hamburger]');
const menu = document.querySelector('[data-header-menu]');
const dropLinks = document.querySelectorAll('[data-drop-link]');
const arrowBack = document.querySelector('[data-arrow-back]');
const dropLink = document.querySelector('[data-dropdown-link]');
const dropMenu = document.querySelector('[data-dropdown-menu]');

if (header && hamburger && menu) {
    hamburger.addEventListener('click', () => {
        hamburger.classList.toggle('_open');
        menu.classList.toggle('_open');
        header.classList.toggle('_open');
        dropMenu.classList.remove('_open');
    });

    if (dropLink && dropMenu) {
        dropLink.addEventListener('click', () => {
            dropMenu.classList.toggle('_open');
        });
    }

    if (arrowBack && dropMenu) {
        arrowBack.addEventListener('click', () => {
            dropMenu.classList.remove('_open');
        });
    }

    dropLinks.forEach((link) => {
        link.addEventListener('click', () => {
            hamburger.classList.remove('_open');
            menu.classList.remove('_open');
        });
    });

    document.addEventListener('click', (e) => {
        if (!header.contains(e.target)) {
            hamburger.classList.remove('_open');
            menu.classList.remove('_open');
        }
    });
}
